/* eslint-disable import/no-cycle */
import { makeServiceCall } from 'redux-core/serviceHelpers';

export const getAllWatchedProductionsCall = makeServiceCall('productions', 'get-watching');

export const isBeingWatchedProductionCall = makeServiceCall('productions', 'is-being-watched');
